import * as VueNS from "vue"
import ResponsesCache, { IResponsesCache } from "@/vue/planning/classes/ResponsesCache"

type CacheHolder = { value: IResponsesCache }

const createCacheHolder = (): CacheHolder => {
	const vue = (VueNS || {}) as { ref?: (value: IResponsesCache) => CacheHolder; default?: { ref?: (value: IResponsesCache) => CacheHolder } }
	const makeRef = vue.ref || vue.default?.ref
	if (typeof makeRef === "function") {
		return makeRef(new ResponsesCache())
	}
	return { value: new ResponsesCache() }
}

const responsesCache: CacheHolder = createCacheHolder()

export default responsesCache